import { Input, Alert, NumberInput } from "@heroui/react";
import { LuInfo } from "react-icons/lu";
import { MapPicker } from "@/components/ui";

const AddressBlock = ({
    prefix,
    watch,
    setValue,
    register,
    label = "Alamat",
}) => {
    const addressData = watch(prefix);

    // Handle map location change
    const handleLocationChange = (location) => {
        if (!location) return;

        setValue(`${prefix}.full_address`, location.formattedAddress || "");
        setValue(`${prefix}.village`, location.village || "");
        setValue(`${prefix}.district`, location.district || "");
        setValue(`${prefix}.city`, location.city || "");
        setValue(`${prefix}.province`, location.province || "");
        setValue(`${prefix}.postal_code`, location.postalCode || "");
        setValue(`${prefix}.lat`, location.lat || null);
        setValue(`${prefix}.lng`, location.lng || null);
        setValue(`${prefix}.google_map_url`, location.googleMapUrl || "");
    };

    return (
        <div className="border-default-200 flex flex-col gap-4 rounded-lg border p-4">
            <h3 className="text-sm font-semibold">{label}</h3>
            <Alert
                color="primary"
                variant="flat"
                icon={
                    <div className="flex items-center justify-center">
                        <LuInfo size={18} className="mx-auto" />
                    </div>
                }
                classNames={{
                    description: "text-xs",
                }}
                title="Pilih lokasi pada peta"
                description="Klik pada peta atau gunakan pencarian untuk menentukan lokasi. Data alamat akan terisi otomatis."
            />

            {/* Map Picker */}
            <MapPicker
                value={{
                    lat: addressData?.lat,
                    lng: addressData?.lng,
                    formattedAddress: addressData?.full_address,
                }}
                onChange={handleLocationChange}
            />

            {/* Address Fields */}
            <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2">
                {/* Alamat Lengkap - Full Width */}
                <div className="md:col-span-2">
                    <Input
                        label="Alamat Lengkap"
                        placeholder="Alamat lengkap"
                        variant="bordered"

                        value={addressData?.full_address || ""}
                        onValueChange={(val) =>
                            setValue(`${prefix}.full_address`, val)
                        }
                    />
                </div>

                {/* RT (1/4) + RW (1/4) + Kelurahan (1/2) */}
                <div className="grid grid-cols-4 gap-4 md:col-span-2">
                    <NumberInput
                        label="RT"
                        placeholder="RT"
                        variant="bordered"

                        size="sm"
                        hideStepper
                        formatOptions={{ useGrouping: false }}
                        value={addressData?.neighborhood_unit || null}
                        onValueChange={(val) =>
                            setValue(`${prefix}.neighborhood_unit`, val)
                        }
                    />
                    <NumberInput
                        label="RW"
                        placeholder="RW"
                        variant="bordered"

                        size="sm"
                        hideStepper
                        formatOptions={{ useGrouping: false }}
                        value={addressData?.sub_neighborhood_unit || null}
                        onValueChange={(val) =>
                            setValue(`${prefix}.sub_neighborhood_unit`, val)
                        }
                    />
                    <div className="col-span-2">
                        <Input
                            label="Kelurahan"
                            placeholder="Kelurahan"
                            variant="bordered"
    
                            size="sm"
                            value={addressData?.village || ""}
                            onValueChange={(val) =>
                                setValue(`${prefix}.village`, val)
                            }
                        />
                    </div>
                </div>

                {/* Kecamatan + Kota */}
                <Input
                    label="Kecamatan"
                    placeholder="Kecamatan"
                    variant="bordered"

                    value={addressData?.district || ""}
                    onValueChange={(val) => setValue(`${prefix}.district`, val)}
                />

                <Input
                    label="Kota/Kabupaten"
                    placeholder="Kota/Kabupaten"
                    variant="bordered"

                    value={addressData?.city || ""}
                    onValueChange={(val) => setValue(`${prefix}.city`, val)}
                />

                {/* Provinsi + Kode Pos */}
                <Input
                    label="Provinsi"
                    placeholder="Provinsi"
                    variant="bordered"

                    value={addressData?.province || ""}
                    onValueChange={(val) => setValue(`${prefix}.province`, val)}
                />

                <NumberInput
                    label="Kode Pos"
                    placeholder="Kode Pos"
                    variant="bordered"

                    hideStepper
                    formatOptions={{ useGrouping: false }}
                    value={addressData?.postal_code || null}
                    onValueChange={(val) =>
                        setValue(`${prefix}.postal_code`, val)
                    }
                />
            </div>
        </div>
    );
};

export default AddressBlock;
